var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"updoc"},[_c('h1',[_vm._v("快应用 SDK版本更新日志")]),_vm._v(" "),_c('ul',_vm._l((_vm.list),function(item,index){return _c('li',{key:index},[_c('h3',[_c('span',[_vm._v("版本："+_vm._s(item.version))]),_c('span',[_vm._v("发布时间："+_vm._s(item.publish_time))])]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(item.log)}})])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a489f242","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/NewHome/SDK/kyySDKUp.vue
// module id = null
// module chunks = 